import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonOne } from '../../../components/ButtonOne/ButtonOne.component';
import { ListItemIcon, Menu, MenuItem } from '@material-ui/core';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import NewMessage from '../../../assets/icons/newMessage.svg';
import { useStyles as useNavBarStyles } from '../../../components/Layout/Navbar/Navbar.styles';
import { useStyles as useNavBarMenuStyles } from '../../../components/Layout/NavbarMenu/NavbarMenu.styles';
import { useStyles } from './MessageCreate.styles';

interface MessageCreateProps {
  onOpenNewMessage: (data: { value: boolean; type: 'standard' | 'helpdesk' }) => void;
}

const MessageCreate: React.FC<MessageCreateProps> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const navBarStyles = useNavBarStyles();
  const navBarMenuStyles = useNavBarMenuStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNewMessage = (type: 'standard' | 'helpdesk') => {
    handleClose();
    props.onOpenNewMessage({ value: true, type: type });
  };

  return (
    <>
      <ButtonOne
        className={classes.addMessageButton}
        variant="contained"
        color="primary"
        onClick={handleClick}
        startIcon={<img src={NewMessage} alt='ikona nowej wiadomości' />}
      >
        {t('messagebox:header.addButton')}
      </ButtonOne>
      <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleClose} className={navBarMenuStyles.sx}>
        <MenuItem disableRipple onClick={() => handleNewMessage('standard')}>
          <ListItemIcon>
            <CreateOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Nowa wiadomość
        </MenuItem>
        <MenuItem disableRipple onClick={() => handleNewMessage('helpdesk')}>
          <ListItemIcon>
            <ContactSupportOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Wiadomość Helpdesk
        </MenuItem>
      </Menu>
    </>
  );
};

export default MessageCreate;
